import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-basket",
  "use": "icon-basket-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-basket\"><path d=\"M15.2 1.3l-6 6.6-1.5-1.3 6-6.6.8.6.7.7zm-1.8 4v2h4.2L15.8 18H4.3L2.4 7.2h4v-2H0L2.6 20h15L20 5.3h-6.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol